export default __webpack_public_path__ + "static/jackschwager-fc136b9acac11568b0053a658b262849.jpg";